import script from "./Otp.vue?vue&type=script&setup=true&lang=js"
export * from "./Otp.vue?vue&type=script&setup=true&lang=js"

import "./Otp.vue?vue&type=style&index=0&id=5458f0a9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5458f0a9"]])

export default __exports__